import EmailBody from "components/emailer/email-body";
import { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

const EmailSignaturesForm = ({ selectedSignature }) => {
  const { body } = selectedSignature;
  const [signatureBody, setSignatureBody] = useState(body);

  useEffect(() => {
    setSignatureBody(body);
  }, [body]);

  const quillRef = useRef(null);
  return (
    <div className="email-signature-form">
      <p>
        <strong>Customize Your Signature</strong>
      </p>
      <div>
        <EmailBody
          quillRef={quillRef}
          className="email-signature--editor"
          placeholderText="No Signature Selected"
          showLinkAndImageOptions={false}
          emailBody={signatureBody}
          setEmailBody={setSignatureBody}
        />
      </div>
    </div>
  );
};

EmailSignaturesForm.propTypes = {
  selectedSignature: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    body: PropTypes.string,
  }).isRequired,
};

export default EmailSignaturesForm;
